import { useEffect, useRef } from 'react';

export const useInterval = (callback: any, hasExpired: boolean) => {
  const savedCallback = useRef<any>();

  // Remember the latest function.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    function tick() {
      savedCallback.current();
    }

    const id = setInterval(tick, 1000);

    if (hasExpired) {
      clearInterval(id);
    }

    return () => clearInterval(id);
  }, [hasExpired]);
};
